export const shouldShowIPAddressesBeta = () => {
  if (window.Reqres) {
    return window.Reqres.request('hasFeature', 'mako', 'ip_management');
  }
  return false;
};

export default shouldShowIPAddressesBeta;
